// src/core-app/ReduxInitializer.jsx

import React from 'react';

//------------------------------------------------------------------------------
// const DEBUG = false && process.env.REACT_APP_ENV === 'development';
//------------------------------------------------------------------------------
/* eslint-disable no-console */

/**
 * @component
 *
 * The first component with access to the redux context.
 * WIP - maybe use to run initializing actions?
 * WIP - help with redirects
 *
 */
const AppInitializer = ({ children }) => {
  return children;
};

export default AppInitializer;
